import React, { useState, useEffect } from 'react';
import GridContainer from '../GridContainer';
import {
    Button, Dialog, Box, Grid, makeStyles, DialogTitle, DialogContent,
    FormControl, Select, InputLabel, TextField,
    CircularProgress, MenuItem,
    OutlinedInput,
} from '@material-ui/core';

import { CustomToast } from '@jumbo/components/custom/Toast';

import { formatRut, LABEL_INPUT_FONT_SIZE, validateRut } from 'routes/Pages/FichasTecnicas/ConstsAndUtils/utils';
import { EXCLUDE_FROM_ODONTOLOGIA, PRIVADOS, TEXT_COLOR_FT } from 'config/config';
import { Save } from '@material-ui/icons';

const addStyle = makeStyles(theme => ({
    dialogRoot: {
        position: 'relative',
    },
    dialogTitleRoot: {
        '& .MuiTypography-h6': {
            fontSize: 16,
            color: theme.palette.common.dark,
        },
    },
}));

const EditModal2 = props => {
    const {
        openDialog = false,
        close,
        dataCrear,
        postData,
        autoridades,
    } = props;

    const [loading, setIsLoading] = useState(false);
    const [formData, setFormData] = useState(dataCrear || {});
    const classes = addStyle();

    // Cuando cambie la fila seleccionada o se abra el modal,
    // sincronizamos el estado local con dataCrear
    useEffect(() => {
        setFormData(dataCrear || {});
        console.log('datacre',dataCrear)
    }, [dataCrear, openDialog]);

    const onCloseDialog = (event, reason) => {
        if (reason !== 'backdropClick') {
            clearData();
            close();
        }
    };

    const clearData = () => {
        setIsLoading(false);
    };

    const handleChange = (field) => (event) => {
        const value = event.target.value;

        if (field === 'nro_resolucion') {
            if (!/^\d*$/.test(value)) return;
            const numericValue = value.replace(/^0+/, '');

            if (numericValue.length <= 9) {
                setFormData(prev => ({
                    ...prev,
                    [field]: numericValue,
                }));
            }
        } else if (field === 'garantia_vigente') {

            setFormData(prev => ({
                ...prev,
                [field]: value,
                'fecha_exp_garantia': ''
            }));


        } else {
            setFormData(prev => ({
                ...prev,
                [field]: value,
            }));
        }

    };

    const validateForm = () => {
        // Todos los campos son opcionales, así que no bloqueamos el botón
        return false;
    };

    return (
        <Dialog open={openDialog} onClose={onCloseDialog}>
            <CustomToast />
            <DialogTitle className={classes.dialogTitleRoot}>
                <Grid container justifyContent='space-between' style={{ color: TEXT_COLOR_FT }}>
                    <Grid item >
                        {formData?.nombre ? 'Editar ' + formData.nom_equipo : 'Editar registro'}
                    </Grid>
                </Grid>
            </DialogTitle>
            <DialogContent dividers>
                <Box
                    display="flex"
                    flexDirection={{ xs: 'column', md: 'row' }}
                    alignItems="center"
                    mb={{ xs: 6, md: 5 }}
                >

                    <GridContainer>

                        {/* Código (no editable) */}
                        <Grid item xs={12} md={6}>
                            <TextField
                                fullWidth
                                margin="dense"
                                variant="outlined"
                                label="Código"
                                value={formData.codigo || ''}
                                disabled
                                InputLabelProps={{
                                    shrink: true,
                                    style: { fontSize: LABEL_INPUT_FONT_SIZE },
                                }}
                            />
                        </Grid>

                        {/* Equipamiento (no editable) */}
                        <Grid item xs={12} md={6}>
                            <TextField
                                fullWidth
                                margin="dense"
                                variant="outlined"
                                label="Equipamiento"
                                value={formData.nom_equipo || ''}
                                disabled
                                InputLabelProps={{
                                    shrink: true,
                                    style: { fontSize: LABEL_INPUT_FONT_SIZE },
                                }}
                            />
                        </Grid>

                        {/* Marca */}
                        <Grid item xs={12} md={6}>
                            <TextField
                                fullWidth
                                margin="dense"
                                variant="outlined"
                                label="Marca"
                                value={formData.marca || ''}
                                onChange={handleChange('marca')}
                                InputLabelProps={{
                                    shrink: true,
                                    style: { fontSize: LABEL_INPUT_FONT_SIZE },
                                }}
                            />
                        </Grid>

                        {/* Modelo */}
                        <Grid item xs={12} md={6}>
                            <TextField
                                fullWidth
                                margin="dense"
                                variant="outlined"
                                label="Modelo"
                                value={formData.modelo || ''}
                                onChange={handleChange('modelo')}
                                InputLabelProps={{
                                    shrink: true,
                                    style: { fontSize: LABEL_INPUT_FONT_SIZE },
                                }}
                            />
                        </Grid>

                        {/* Nº Serie */}
                        <Grid item xs={12} md={6}>
                            <TextField
                                fullWidth
                                margin="dense"
                                variant="outlined"
                                label="Nº Serie"
                                value={formData.nro_serie || ''}
                                onChange={handleChange('nro_serie')}
                                InputLabelProps={{
                                    shrink: true,
                                    style: { fontSize: LABEL_INPUT_FONT_SIZE },
                                }}
                            />
                        </Grid>

                        {/* Garantía vigente */}
                        <Grid item xs={12} md={6}>
                            <FormControl fullWidth margin="dense" variant="outlined">
                                <InputLabel
                                    shrink
                                    style={{ fontSize: LABEL_INPUT_FONT_SIZE }}
                                >
                                    Garantía vigente
                                </InputLabel>
                                <Select
                                    value={formData.garantia_vigente}
                                    onChange={handleChange('garantia_vigente')}
                                    label="Garantía vigente"
                                    inputProps={{}}
                                    input={
                                        <OutlinedInput
                                            notched
                                            label="Garantía vigente"
                                        />
                                    }
                                >
                                    <MenuItem value="">
                                        <em>Seleccione</em>
                                    </MenuItem>
                                    <MenuItem value="SI">Sí</MenuItem>
                                    <MenuItem value="NO">No</MenuItem>
                                </Select>
                            </FormControl>
                        </Grid>

                        {/* Fecha expiración garantía */}
                        <Grid item xs={12} md={6}>
                            <TextField
                                disabled={formData.garantia_vigente === 'SI' ? false : true}
                                type='date'
                                fullWidth
                                margin="dense"
                                variant="outlined"
                                label="Fecha expiración garantía"
                                placeholder="dd/mm/aaaa"
                                value={formData.fecha_exp_garantia || ''}
                                onChange={handleChange('fecha_exp_garantia')}
                                InputLabelProps={{
                                    shrink: true,
                                    style: { fontSize: LABEL_INPUT_FONT_SIZE },
                                }}
                                inputProps={{
                                    maxLength: 10,
                                }}
                            />
                        </Grid>

                        {/* Periodicidad mantención */}
                        <Grid item xs={12} md={6}>
                            <FormControl fullWidth margin="dense" variant="outlined">
                                <InputLabel
                                    shrink
                                    style={{ fontSize: LABEL_INPUT_FONT_SIZE }}
                                >
                                    Periodicidad mantención
                                </InputLabel>
                                <Select
                                    value={formData.periodicidad_mantencion || ''}
                                    onChange={handleChange('periodicidad_mantencion')}
                                    label="Periodicidad mantención"
                                    input={
                                        <OutlinedInput
                                            notched
                                            label="Periodicidad mantención"
                                        />
                                    }
                                >
                                    <MenuItem value=""><em>Seleccione</em></MenuItem>
                                    <MenuItem value="Mensual">Mensual</MenuItem>
                                    <MenuItem value="Bimensual">Bimensual</MenuItem>
                                    <MenuItem value="Trimestral">Trimestral</MenuItem>
                                    <MenuItem value="Semestral">Semestral</MenuItem>
                                    <MenuItem value="Anual">Anual</MenuItem>
                                </Select>
                            </FormControl>
                        </Grid>

                        {/* Propio / Comodato */}
                        <Grid item xs={12} md={6}>
                            <FormControl fullWidth margin="dense" variant="outlined">
                                <InputLabel
                                    shrink
                                    style={{ fontSize: LABEL_INPUT_FONT_SIZE }}
                                    label="Propio / Comodato"
                                >
                                    Propio / Comodato
                                </InputLabel>
                                <Select
                                    value={formData.id_tipo_servicio || ''}
                                    onChange={handleChange('id_tipo_servicio')}
                                    label="Propio / Comodato"
                                    input={
                                        <OutlinedInput
                                            notched
                                            label="Propio / Comodato"
                                        />
                                    }
                                >
                                    <MenuItem value=""><em>Seleccione</em></MenuItem>
                                    <MenuItem value="PROPIO">Propio</MenuItem>
                                    <MenuItem value="COMODATO">Comodato</MenuItem>
                                </Select>
                            </FormControl>
                        </Grid>

                        {/* Nº Autorización sanitaria */}
                        <Grid item xs={12} md={6}>
                            <TextField
                                fullWidth
                                margin="dense"
                                variant="outlined"
                                label="Nº Autorización sanitaria"
                                value={formData.nro_resolucion || ''}
                                onChange={handleChange('nro_resolucion')}
                                InputLabelProps={{
                                    shrink: true,
                                    style: { fontSize: LABEL_INPUT_FONT_SIZE },
                                }}
                            />
                        </Grid>

                        {/* Fecha Resolución */}
                        <Grid item xs={12} md={6}>
                            <TextField
                                fullWidth
                                type='date'
                                margin="dense"
                                variant="outlined"
                                label="Fecha Resolución"
                                placeholder="dd/mm/aaaa"
                                value={formData.fecha_resolucion || ''}
                                onChange={handleChange('fecha_resolucion')}
                                InputLabelProps={{
                                    shrink: true,
                                    style: { fontSize: LABEL_INPUT_FONT_SIZE },
                                }}
                                inputProps={{
                                    maxLength: 10,
                                }}
                            />
                        </Grid>

                        {/* Autoridad que otorga */}
                        <Grid item xs={6}>

                            <FormControl size='small' fullWidth>
                                <InputLabel
                                    inputlabelprops={{ style: LABEL_INPUT_FONT_SIZE, shrink: true }}
                                    htmlFor="grouped-native-select"
                                    style={{ marginTop: -7, marginLeft: 15, fontSize: 14 }}>
                                    Autoridad que otorga
                                </InputLabel>
                                <Select
                                    inputlabelprops={{ style: LABEL_INPUT_FONT_SIZE, shrink: true }}
                                    native
                                    label='Autoridad que otorga'
                                    id="grouped-native-select"
                                    fullWidth
                                    variant='outlined'
                                    value={formData.nom_autoridad || ''}
                                    onChange={(e) => {
                                        const val = e.target.value
                                        setFormData(prev => ({
                                            ...prev,
                                            nom_autoridad: val,
                                        }));

                                    }}

                                >
                                    {
                                        autoridades.map((option, index) => {
                                            return <option key={index + 1} value={option.value}>
                                                {option.label}
                                            </option>
                                        })
                                    }
                                </Select>
                            </FormControl>

                        </Grid>

                    </GridContainer>


                </Box>

                <Box display="flex" justifyContent="flex-end" mb={4}>
                    <Button onClick={onCloseDialog} disabled={loading} variant='outlined'>
                        Cerrar
                    </Button>
                    <Box ml={2}>
                        <Button
                            variant="outlined"
                            color="primary"
                            onClick={() => {
                                //setIsLoading(true);
                                postData(formData);
                            }}
                            disabled={validateForm() || loading}
                        >
                            <Save style={{ marginRight: 10 }} />
                            {loading ? (
                                <CircularProgress
                                    color="inherit"
                                    style={{ height: '22px', width: '22px' }}
                                />
                            ) : (
                                'Actualizar'
                            )}
                        </Button>
                    </Box>
                </Box>
            </DialogContent>
        </Dialog>
    );
};

export default EditModal2;

